'use strict'
export default function (fixedMenuHeight = 0) {
	if ($(window).width() < 1200) {
		fixedMenuHeight = -10;
	}
	var url = new URL(window.location.href)
	var scrollToElement = url.searchParams.get('scrollTo')

	jQuery(function ($) {
		$(function () {
			$('a[data-scroll-to]').on('click', function (e) {
				e.preventDefault()
				$('html,body').animate({
					scrollTop: $($(this).attr('href')).offset().top - fixedMenuHeight + 'px'
				}, 1000, 'swing')
			})

			if (scrollToElement) {
				setTimeout(function () {
					$('html,body').animate({
						scrollTop: $('#' + scrollToElement).offset().top - fixedMenuHeight + 'px'
					}, 1000, 'swing')
				}, 100)
			}
		})
	})
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/scrollToElement.js